













import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import TagSelectForm from "@/components/Organisms/OnboardingFloatingView/Organisms/TagSelectForm/index.vue";
import { getTopCompanyFollowees } from "@/api";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompaniesForm",
  components: {
    TagSelectForm
  },
  props: {
    companies: {
      type: Array as PropType<Props["companies"]>,
      required: true
    }
  },
  data() {
    return {
      suggestionCompanies: [],
      topCompanies: [],
      loadingTopCompanies: false
    };
  },
  computed: {
    partnerUser() {
      return this.$store.state.domains.user.partnerUser;
    }
  },
  mounted() {
    this.getTopCompanies();
  },
  methods: {
    exclusionOwnOrganization(companies) {
      return companies.filter(
        company => company.id !== this.partnerUser?.partner.company.id
      );
    },
    async searchCompanies(keyword) {
      if (!keyword) {
        this.suggestionCompanies = [];
        return;
      }
      const { data } = await getTopCompanyFollowees({
        name: keyword,
        limit: 999
      });
      this.suggestionCompanies = this.exclusionOwnOrganization(data.companies);
    },
    async getTopCompanies() {
      this.loadingTopCompanies = true;
      const { data } = await getTopCompanyFollowees({ limit: 5 });
      this.topCompanies = this.exclusionOwnOrganization(data.companies);
      this.loadingTopCompanies = false;
    }
  }
});
